import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Card, Divider } from '@mui/material';

//*files
import cssClasses from './Inventory.module.css';
import { AllotmentDiv } from '../../../../Subcomponents/FloorComponent/FloorComponents';
import WingsCard from '../../../../Subcomponents/WingsCard/WingsCard';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';
import {
  getAllSalesByProjectFloors,
  getAllSalesByProjectFloorsUser,
  getAllSalesByProjectWingsUser,
  getAllUnitsByProjectId,
  getAllUnitsByProjectIdWings,
  getAllUnitsByWingId,
  getAllWingsByProjectId,
  getProjectByProjectName,
} from '../../../../Services/SustenanceService';
import ProjectIcon from '../../../../Assets/Images/Common/noProjectFound.svg';
import DropDown from '../../../../Subcomponents/DropDown';
import { groupBy, orderBy, uniqBy } from 'lodash';
import ViewToggleSwitch from '../../../../Subcomponents/ViewSwitch/ViewToggleSwitch';
import { dismissLoader } from '../../../../Services/loader';

function Inventory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [AllWings, setAllWings] = useState([]);
  const [ProjectData, setProjectData] = useState([]);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [TotalWings, setTotalWings] = useState(0);
  const [UnitStatus, setUnitStatus] = useState([]);
  const [noWingsPresent, setNoWingsPresent] = useState(null);
  const [mode, setMode] = useState("Card View");
  const [smAccess, setSmAccss] = useState("");
  const { projectId } = useParams();
  const SaleUserId = useRef("");
  useEffect(() => {
    console.log('Project-Name', projectId);
  }, [projectId]);

  useEffect(() => {
    SaleUserId.current = loggedInUser.userId;
    dispatch(action.activeMenu('inventory'));
    getProject();
  }, []);

  async function getProject() {
    getProjectByProjectName(projectId)
      .then((resp) => {
        setProjectData(resp.data[0]);
        if (resp.data[0]) {
          setSmAccss(resp.data[0].smAccess)
          getAllWingsByProjectId(projectId)
            .then((res) => {
              const Data = uniqBy(res.data, 'wingId.wingId');
              if (loggedInUser.roleId.level === 1) {
                if (Data.length > 0) {
                  setNoWingsPresent(true);
                } else {
                  setNoWingsPresent(false);
                }
                setAllWings(Data);
                setTotalWings(Data.length);
                getAllUnitsByProjectId(projectId)
                  .then((response) => {
                    setUnitStatus(response.data);
                    setTotalUnits(response.count);
                  })

                  .catch((err) => {
                    console.error('getAllUnitsByProjectId', err);
                  });
              } else {
                if (resp.data[0].smAccess === "Wings") {

                  getAllSalesByProjectWingsUser(projectId, SaleUserId.current).then((response) => {
                    const filteredData = Data.filter(item1 =>
                      response.data.some(item2 => item1.wingId.wingId === item2.wingId)
                    );
                    if (filteredData.length > 0) {
                      setNoWingsPresent(true);
                    } else {
                      setNoWingsPresent(false);
                    }
                    setAllWings(filteredData);
                    setTotalWings(filteredData.length);

                    let allStatuses = [];
                    let allUnitCounts = [];
                    // Create an array of promises
                    const promises = filteredData.map(async (ele) => {
                      try {
                        const unitresponce = await getAllUnitsByProjectIdWings(projectId, ele.wingId.wingId);
                        // console.log("allUnitCounts", unitresponce.data);
                        allStatuses.push(unitresponce.data);
                        allUnitCounts.push(unitresponce.count);
                      } catch (err) {
                        console.error('getAllUnitsByProjectIdWings error', err);
                      }
                    });
                    Promise.all(promises)
                      .then(() => {
                        setUnitStatus(allStatuses.flat());
                        setTotalUnits(allStatuses.flat().length);
                      })
                      .catch((err) => {
                        console.error('Error in Promise.all', err);
                      });

                  })
                    .catch((err) => {
                      console.error('getAllUnitsByProjectId', err);
                    });
                } else if (resp.data[0].smAccess === "Floors") {
                  getAllSalesByProjectFloorsUser(projectId, SaleUserId.current).then((response) => {
                    const filteredData = Data.filter(item1 =>
                      response.data.some(item2 => item1.wingId.wingId === item2.wingId)
                    );
                    if (filteredData.length > 0) {
                      setNoWingsPresent(true);
                    } else {
                      setNoWingsPresent(false);
                    }
                    setAllWings(filteredData);
                    setTotalWings(filteredData.length);
                    // console.log("total count unit",filteredData)

                    let filteredDataFloorAll = [];
                    // console.log('All data processed successfully dataUnit', filteredData);
                    const promises = filteredData.map(async (ele) => {
                      try {
                        const unitResponse = await getAllUnitsByWingId(projectId, ele.wingId.wingId);
                        const dataUnit = groupBy(unitResponse.data, 'unitId.floorNo');
                        // console.log("All data processed", unitResponse)
                        const salesResponse = await getAllSalesByProjectFloors(projectId, SaleUserId.current, ele.wingId.wingId);
                        const filteredDataFloor = Object.entries(dataUnit)
                          .filter(([floorNo, items]) =>
                            salesResponse.data.some(item2 => item2.floorNo === floorNo)
                          )
                          .reduce((acc, [floorNo, items]) => {
                            acc[floorNo] = items;
                            return acc;
                          }, {});
                        // console.log("All data processed", filteredDataFloor)
                        filteredDataFloorAll.push(filteredDataFloor);
                        const totalLength = Object.values(filteredDataFloor).reduce((sum, array) => sum + array.length, 0);
                        setTotalUnits(prev => prev + totalLength);
                        setUnitStatus(dataUnit.data);


                        dismissLoader();
                      } catch (err) {
                        console.error('Error processing unit and sales data:', err);
                        dismissLoader();
                      }
                    });

                    Promise.all(promises)
                      .then(() => {
                        const newFloorUnitData = filteredDataFloorAll
                          .map(ele => Object.values(ele)) // Extract values
                          .flat();
                        setUnitStatus(newFloorUnitData.flat());

                      })
                      .catch((err) => {
                        console.error('Error in processing all promises:', err);
                      });



                  })
                    .catch((err) => {
                      console.error('getAllSalesByProjectFloorsUser', err);
                    });
                }
                else {
                  if (Data.length > 0) {
                    setNoWingsPresent(true);
                  } else {
                    setNoWingsPresent(false);
                  }
                  setAllWings(Data);
                  setTotalWings(Data.length);
                  getAllUnitsByProjectId(projectId)
                    .then((response) => {
                      setUnitStatus(response.data);
                      setTotalUnits(response.count);
                    }).catch((err) => {
                      console.error("getAllUnitsByProjectId", err)
                    });
                }
              }

            })
            .catch((err) => {
              console.error('getAllWingsByProjectId', err);
            })

        }
      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });
  }

  function goToWing(wingName) {
    navigate(`/home/Sustenance/Details/${projectId}/Inventory/${wingName}`, {
      state: { TotalWings }
    });
  }

  return (
    <Box className={cssClasses.Container}>
      <Box className={cssClasses.SubContainer}>
        <Box className={cssClasses.DivContainer}>
          <Box className={cssClasses.HeaderTitle}>
            {ProjectData?.projectName}
          </Box>
          <Box className={cssClasses.SubTitle} mb={'1rem'} mt={'1rem'}>
            {ProjectData?.addressLine1} , {ProjectData?.addressLine2} , {ProjectData?.addressLine3}
          </Box>
        </Box>
      </Box>


      <Divider />

      <Box className={cssClasses.FirstDiv}>
        <Box mt={2} >
          <Box className={cssClasses.Title}>
            Total Wings :
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {TotalWings}
            </Box>{' '}
          </Box>
        </Box>

        <Box mt={2} >

          <Box className={cssClasses.Title}>
            Total Units :
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {TotalUnits}
            </Box>{' '}
          </Box>
        </Box>

        <Box margin={'1rem 2rem'}>
          <ViewToggleSwitch setMode={setMode} />
        </Box>


      </Box>

      <Divider />

      <Box className={cssClasses.BoxDiv} >
        <AllotmentDiv
          style={{ backgroundColor: '#D1FADF' }}
          content={'Available '}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'Available'
              ).length
              : '0'
          }
        />
        <AllotmentDiv
          style={{ backgroundColor: '#FEF0C7' }}
          content={'On Hold '}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'On Hold'
              ).length
              : '0'
          }
        />
        {/* // ! to hide these status as per client requirement => 28 March, 2023 */}
        {/* <AllotmentDiv
          style={{ backgroundColor: '#FEE4E2' }}
          // content={'Alloted'}
          content={'Payment Pending'}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === 'Payment Pending')
                .length
              : '0'
          }
        /> */}

        <AllotmentDiv
          style={{ backgroundColor: '#FFE6D5' }}
          content={'Preselected'}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'Preselected'
              ).length
              : '0'
          }
        />

        {/* <AllotmentDiv
          style={{ backgroundColor: '#EFF8FF' }}
          content={'Kyc Pending'}
          Quantity={UnitStatus
            ? UnitStatus?.filter(
              (f) => f.unitId.inventoryStatusId.status === 'Kyc Pending').length : "0"}
        />
        <AllotmentDiv
          style={{ backgroundColor: '#ECFDFF' }}
          content={'Kyc Done'}
          Quantity={UnitStatus
            ? UnitStatus?.filter(
              (f) => f.unitId.inventoryStatusId.status === 'Kyc Done').length : "0"}
        />
        <AllotmentDiv
          style={{ backgroundColor: '#FFFAEB' }}
          content={'SDR Payment Pending'}
          Quantity={UnitStatus
            ? UnitStatus?.filter(
              (f) => f.unitId.inventoryStatusId.status === 'SDR Payment Pending').length : "0"}
        />
        <AllotmentDiv
          style={{ backgroundColor: '#F4EBFF' }}
          content={'Reserved '}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'Reserved'
              ).length
              : '0'
          }
        />
        <AllotmentDiv
          style={{ backgroundColor: '#F2F4F7' }}
          content={'Locked'}
          Quantity={
            UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'Locked'
              ).length
              : '0'
          }
        /> */}
      </Box>

      <Divider />

      {mode === 'Card View' && (
        <>
          <Box className={cssClasses.MainDiv}>
            <Box className={cssClasses.FlexRow}>
              {orderBy(AllWings, "wingName")?.map((wing, index) => (
                <Box component={'span'} key={`${wing}_${index}`}>
                  <WingsCard
                    clicked={() => {
                      goToWing(wing.wingId.wingId);
                    }}
                    wingName={wing.wingId.displayName ? wing.wingId.displayName : wing.wingId.wingName}
                  // wingName={wing.wingId.wingName}
                  />
                </Box>
              ))}
            </Box>
          </Box>

          {noWingsPresent === false && (
            <Box>
              <Box className={cssClasses.noDataMsg}>
                <Box className={cssClasses.emptyIcon}>
                  <img src={ProjectIcon} alt='No Wings' />
                </Box>
                <Box className={cssClasses.emptyTitle}>No Wings found</Box>
              </Box>
            </Box>
          )}
        </>
      )}

      {mode === 'Table View' && (
        <>
          <Box margin={'1rem'}>
            {orderBy(AllWings, "wingName")?.map((wing, index) => (
              <Box mb={2}>
                <Card
                  onClick={() => {
                    goToWing(wing.wingId.wingId);
                  }}
                  sx={{
                    padding: "2rem",
                    // color: "#344054",
                    fontSize: "1.6rem",
                    fontFamily: "Inter-Regular",
                    lineHeight: "2.4rem",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow:
                      "0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important",
                    borderRadius: "0.8rem !important",
                    border: " 1px solid rgba(0, 0, 0, 0.12) !important",
                    gap: "1rem",
                    cursor: 'pointer',
                  }}
                  key={`${wing}_${index}`}
                >
                  {/* <Box >
                    Wing {wing.wingId.wingName}
                  </Box> */}

                  <Box >
                    Wing {wing.wingId.displayName ? wing.wingId.displayName : wing.wingId.wingName}
                  </Box>
                </Card>
              </Box>
            ))}

            {noWingsPresent === false && (
              <Box>
                <Box className={cssClasses.noDataMsg}>
                  <Box className={cssClasses.emptyIcon}>
                    <img src={ProjectIcon} alt='No Wings' />
                  </Box>
                  <Box className={cssClasses.emptyTitle}>No Wings found</Box>
                </Box>
              </Box>
            )}
          </Box>
        </>
      )}


    </Box>
  );
}

export default Inventory;
